import { render, staticRenderFns } from "./QueryResult.vue?vue&type=template&id=16531d8e&scoped=true"
import script from "./QueryResult.vue?vue&type=script&lang=js"
export * from "./QueryResult.vue?vue&type=script&lang=js"
import style0 from "./QueryResult.vue?vue&type=style&index=0&id=16531d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16531d8e",
  null
  
)

export default component.exports